import CoreApi from '@/api/CoreApi';

export function getVirtualRobotLoadingStatus(): Promise<{
  data: { status: number; token: string };
}> {
  try {
    return CoreApi.axiosClient.get('/virtual-robot/status');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error(error);
    throw new Error(`Failed to load virtual robot status: ${error.message}`);
  }
}

export function configureVirtualRobot(configuration: object) {
  try {
    return CoreApi.axiosClient.post('/virtual-robot/configure', configuration);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error(error);
    throw new Error(
      `Failed to configure virtual robot status: ${error.message}`,
    );
  }
}
